// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"92":"0a0943b1","221":"95513341","398":"7aa3c93e","437":"1e9daeaf","527":"310a5dff","548":"91e62d02"}[chunkId] + ".js";
};